import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowLeftStopLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { fill: "currentColor", d: "m10 12-.354-.354-.353.354.353.354zm10 .5a.5.5 0 0 0 0-1zm-4.354-6.854-6 6 .708.708 6-6zm-6 6.708 6 6 .708-.708-6-6zM10 12.5h10v-1H10z" }), _jsx("path", { stroke: "currentColor", d: "M4 5v14" })] }) });
}
const ArrowLeftStopLight = forwardRef(_ArrowLeftStopLight);
export { ArrowLeftStopLight };
